import { render, staticRenderFns } from "./TaskStatement.vue?vue&type=template&id=68351bd5&scoped=true&"
import script from "./TaskStatement.vue?vue&type=script&lang=js&"
export * from "./TaskStatement.vue?vue&type=script&lang=js&"
import style0 from "./TaskStatement.vue?vue&type=style&index=0&id=68351bd5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68351bd5",
  null
  
)

export default component.exports